<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
          <el-breadcrumb-item>产品管理</el-breadcrumb-item>
          <el-breadcrumb-item>颗粒分类</el-breadcrumb-item>
        </el-breadcrumb>

  <el-row style="margin-top:10px">

       <el-col :span="23" style="text-align:right">
        <el-button size="small" type="primary" @click="searchPcs()">{{$t("base.search")}}</el-button>
        <el-button  :title="$t('base.new')" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="showPcs()"></el-button>
      </el-col>
  </el-row>
   <el-divider></el-divider>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            width="75"
          ></el-table-column>
          <el-table-column prop="title" label="名称">
          </el-table-column>
           <el-table-column prop="pic" label="图片">
            <template slot-scope="scope">
               <el-image
    style="width: 40px; height: 40px"
    :src="scope.row.pic" >
  </el-image>
            </template>
           </el-table-column>
          <el-table-column prop="sort" label="排序">
            </el-table-column>
          <el-table-column :label="$t('base.opt')" column-key="opt" width="300">
            <template  slot-scope="scope"   >
              <el-button
                size="mini"
                type="text"
                @click="showPcs(scope.row)"
                >{{$t("base.edit")}}</el-button
              >
               <el-divider direction="vertical"></el-divider>
              <el-button
              size="mini"
                type="text"
                @click="handleDelete(scope.row)"
                >{{$t("base.del")}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="颗粒分组" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
  <el-form
          :model="pcs"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
          size="mini"
        >
        <el-form-item label="名称" prop="title">
            <el-input v-model="pcs.title" maxlength="20"></el-input>
          </el-form-item>

          <el-form-item label="排序" prop="sort">
              <el-input v-model="pcs.sort" maxlength="3" type="number" ></el-input>
          </el-form-item>
          <el-form-item label="最小值" prop="min">
              <el-input v-model="pcs.min" maxlength="5" type="number" ></el-input>
          </el-form-item>
          <el-form-item label="最大值" prop="max">
              <el-input v-model="pcs.max" maxlength="5" type="number" ></el-input>
          </el-form-item>
           <el-form-item label="图片" prop="pic">
             <el-upload
            style="text-align:left"
              class="avatar-uploader"
              name="upload"
              action="http://resource.ddyuewu.com/resource/upload?isauth=0&type=2&program_type=BASE&filename="
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <el-image  v-if="pcs.pic" :src="pcs.pic" class="avatar"></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-button  v-if="pcs.pic" type="text" @click="pcs.pic=''">删除图片</el-button>
        </el-form-item>
        </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="savePcs()">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'RoleList',
  data () {
    return {
      user: {},
      pcs: {
      },
      tabledata: [],
      dialogFormVisible: false,
      rules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    var self = this
    let user = window.localStorage.getItem('customer')
    if (user) {
      this.user = JSON.parse(user)
      self.searchPcs()
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    handleAvatarSuccess (response) {
      this.pcs.pic = response.url
      this.$forceUpdate()
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    showPcs (row) {
      if (row) {
        this.pcs = Object.assign({}, row)
      } else {
        this.pcs = {sort: 0, pic: null,max:0,min:0}
      }
      this.dialogFormVisible = true
    },

    savePcs () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          let url = '/product/pcs/add'
          if (this.pcs.innerid) {
            url = '/product/pcs/edit'
          } 
          Vue.axios
            .post(url, this.pcs)
            .then((res) => {
              if (res.data.errcode === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('base.saveSuccess'),
                  type: 'success'
                })
                this.searchPcs()
                this.dialogFormVisible = false
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },

    searchPcs () {
      var self = this
      Vue.axios
        .post('/product/pcs/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    },
    
    handleDelete (row) {
      this.$confirm(
        '确认删除' + row.title + '？',
        this.$t('base.info'),
        {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/product/pcs/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: self.$t('base.delSuccess')
                })
                self.searchPcs()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/ProductParams/Pcs.vue